import type { Theme } from "@mui/material/styles";
import { isOhbatRazaEvent } from "@/utils/raza-event-display";
import { googleCalendarColorHex } from "@/utils/google-calendar-event-colors";
import { razaEventOhbatTypeBackground } from "@/theme/raza-event-ohbat-type-color";
import { missingSadaratBorderLeft, shouldFlagMissingSadarat } from "../missing-sadarat-highlight";
import type { RazaEventsCalendarEvent } from "./types";

export function calendarEventStyle(theme: Theme, event: RazaEventsCalendarEvent) {
  if (event.overlayKind === "hall") {
    return {
      backgroundColor: theme.palette.secondary.dark,
      color: theme.palette.common.white,
      border: `1px dashed ${theme.palette.secondary.light}`,
      opacity: 0.92,
    };
  }

  const row = event.resource;
  const missingSadarat = row && shouldFlagMissingSadarat(row);
  const purposeColor = !isOhbatRazaEvent(row)
    ? googleCalendarColorHex(
        typeof row?.purposeCalendarColorId === "string" ? row.purposeCalendarColorId : null
      )
    : null;
  const backgroundColor =
    purposeColor ??
    (row && !isOhbatRazaEvent(row)
      ? theme.palette.info.dark
      : razaEventOhbatTypeBackground(String(row?.ohbatType), theme));
  return {
    backgroundColor,
    color: theme.palette.common.white,
    ...(missingSadarat ? { borderLeft: missingSadaratBorderLeft(theme) } : {}),
  };
}
